export const STORE_KEY = 'paymentMethods';
